import React, { useState, useEffect } from 'react';
import templateServices from '../../services/TemplateServices';
import Constants from '../../common/Constants';
import {useSelector} from 'react-redux';

const BodyLeftComponent = (props) =>{
    const templateData = useSelector(state => state.LayoutTemplateSlice.templateData);
    const currentViewContainer = useSelector(state => state.LayoutTemplateSlice.currentViewContainer);
    const currentPageContainer = useSelector(state => state.LayoutTemplateSlice.currentPageContainer);
    const sportId = useSelector(state => state.SportsSlice.options.sportId)
		let container = 'bodyContainer';
		let position = 'leftContainer';

    let [compsList, setCompsList] = useState([]);

    useEffect(() => {
      const dataComps = templateServices.listDataCompsByContainerPosition(templateData, currentViewContainer, currentPageContainer, container, position);
      setCompsList(templateServices.listComponentsByDataNoGrid(dataComps, props.router) || (<div></div>))
    }, [currentViewContainer, currentPageContainer])
    return (
      <div id="BodyLeftComponent" className={props.className}>    
        <div className={`LeftMenuComponent ${window.env.enableAnnouncement ? '' : 'no-announcement'} ${sportId === Constants.HORSE_RACING_ID && 'horse-racing'}`}>
          {compsList}
        </div>
      </div> 
    );

}


export default React.memo(BodyLeftComponent);



// WEBPACK FOOTER //
// ./src/app/components/BodyLeftComponent/index.js